// Module
var code = "<react-component name=\"PosProductList\"></react-component>\n";
// Exports
module.exports = code;